import { render, staticRenderFns } from "./lookbandaccount.vue?vue&type=template&id=5b69390f&scoped=true"
import script from "./lookbandaccount.vue?vue&type=script&lang=js"
export * from "./lookbandaccount.vue?vue&type=script&lang=js"
import style0 from "./lookbandaccount.vue?vue&type=style&index=0&id=5b69390f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69390f",
  null
  
)

export default component.exports